module.exports = "https://s.pinimg.com/webapp/style/images/VI@2x-2786bf5e.png";